import { Link } from "@tanstack/react-router";
import { ArrowRight, Sparkles } from "lucide-react";

type Props = {
  variant?: "inline" | "final";
  headline?: string;
  body?: string;
};

export function ArticleCTA({
  variant = "inline",
  headline,
  body,
}: Props) {
  const isFinal = variant === "final";
  return (
    <aside
      className={
        "not-prose my-10 rounded-3xl border border-primary/20 bg-gradient-to-br from-primary/10 via-background to-primary-glow/10 p-6 sm:p-8 shadow-sm"
      }
      aria-label="Comece grátis no Seu Bolso Tranquilo"
    >
      <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-primary mb-3">
        <Sparkles className="size-4" />
        {isFinal ? "Sua vez" : "Aplique agora"}
      </div>
      <h3 className="text-xl sm:text-2xl font-bold text-foreground mb-2">
        {headline ??
          (isFinal
            ? "Coloque em prática no Seu Bolso Tranquilo"
            : "Quer fazer isso sem planilha?")}
      </h3>
      <p className="text-muted-foreground mb-5 leading-relaxed">
        {body ??
          (isFinal
            ? "Crie sua conta grátis e organize receitas, despesas e metas em menos de 2 minutos. Sem conectar banco, sem cartão de crédito."
            : "O Seu Bolso Tranquilo organiza suas receitas, despesas e metas com gráficos claros e insights automáticos — em menos de 2 minutos.")}
      </p>
      <Link
        to="/auth"
        className="inline-flex items-center gap-2 rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground hover:bg-primary/90 transition-colors"
      >
        Começar grátis
        <ArrowRight className="size-4" />
      </Link>
    </aside>
  );
}